import Swal from 'sweetalert2';

export const warning = (title: string, text?: string, showCancelButton = false) => {
    return Swal.fire({
        title: title,
        text: text,
        icon: 'warning',
        showCancelButton: showCancelButton,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
    });
};

export const success = (title: string, text?: string) => {
    return Swal.fire(title, text, 'success');
};

export const toastSuccess = (title: string, text?: string) => {
    return Swal.fire({
        title: title,
        text: text,
        icon: 'success',
        toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 2000,
    });
};

export const toastError = (title: string, text?: string) => {
    return Swal.fire({
        title: title,
        text: text,
        icon: 'error',
        toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 2000,
    });
};

// Updated confirm function
export const confirm = ({ title, message, confirmText, cancelText, onConfirm, onCancel }: { title: string, message: string, confirmText: string, cancelText: string, onConfirm: () => void, onCancel?: () => void }) => {
    return Swal.fire({
        title: title,
        text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: confirmText,
        cancelButtonText: cancelText,
    }).then((result) => {
        if (result.isConfirmed) {
            onConfirm();
        } else if (result.dismiss === Swal.DismissReason.cancel && onCancel) {
            onCancel();
        }
    });
};
